import css from './index.module.scss';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';
import NextImage from '@/components/NextImage';
import ProductRecommand from '@elem/compCommon/ProductRecomand';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_delta_delta_max', 'product_ps_delta_delta_pro', 'product_ps_river_river_256'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    nl: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_sp_400w_rigid_solar_panel', 'product_ps_delta_delta_2', 'product_ps_delta_delta_3_s'],
};

export default function SolarPanel() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('100wrigidsolarpanel');
    const webpUrl = '/media/100w_rigid/h5/';

    const videoSource: any = {
        us: ['/video/solarpanels_100w/4.webm', '/video/solarpanels_100w/4.mp4'],
        de: ['/video/solarpanels_100w/4_de.webm', '/video/solarpanels_100w/4_de.mp4'],
        fr: ['/video/solarpanels_100w/4_fr.webm', '/video/solarpanels_100w/4_fr.mp4'],
        jp: ['/video/solarpanels_100w/4_jp.webm', '/video/solarpanels_100w/4_jp.mp4'],
        cis: ['/video/solarpanels_100w/4_ru.webm', '/video/solarpanels_100w/4_ru.mp4'],
    };

    const props = {
        more: `https://${locale}.ecoflow.com/pages/portable-power-stations`,
        data: [
            {
                productId: '9935710912788',
                variantId: '51194414924052',
            },
            {
                productId: '9935700132116',
                variantId: '51194378682644',
            },
            {
                productId: '9935714386196',
                variantId: '51427570286868',
            },
        ],
    };

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div className="page-solarpanel-banner">
                <BannerModule
                    data={[
                        {
                            bgImgs: ['KV.webp', 'KV.jpg'],
                            title: t('solarpanels_100w.title'),
                            des: t('solarpanels_100w.des'),
                        },
                    ]}
                    config={{ isShowLogo: false, theme: 'black', webpUrl }}
                />
            </div>
            <div className="banner-content">
                <div className="section sec_top">
                    <div className="tit">{t('solarpanels_100w.second_hight_conversion_rate_H5')}</div>
                    <div className="bg-img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_100w/h5/sec_top.webp')}
                            src={require('@publicLocal/product/solarpanel_100w/h5/sec_top.jpg')}
                            className="fullImgs"
                            alt={t('solarpanels_100w.second_hight_conversion_rate_H5')}
                        />
                    </div>
                </div>
                <div className="section sec_middle">
                    <div className="sec_middle_left">
                        <div className="tit">
                            <div className="text1">{t('solarpanels_100w.second_powerfully')}</div>
                            <div className="text2">{t('solarpanels_100w.second_mounting_holes_h5')}</div>
                        </div>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_100w/h5/sec_middle_left.webp')}
                                src={require('@publicLocal/product/solarpanel_100w/h5/sec_middle_left.jpg')}
                                className="fullImgs"
                                alt={t('solarpanels_100w.second_powerfully')}
                            />
                        </div>
                    </div>
                    <div className="sec_middle_right">
                        <div className="tit">
                            {locale === 'fr' ? (
                                <>
                                    <div className="text2">{t('solarpanels_100w.second_waterproof')}</div>
                                    <div className="text1">{t('solarpanels_100w.second_ip')}</div>
                                </>
                            ) : (
                                <>
                                    <div className="text1">{t('solarpanels_100w.second_ip')}</div>
                                    <div className="text2">{t('solarpanels_100w.second_waterproof')}</div>
                                </>
                            )}
                        </div>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_100w/h5/sec_middle_right.webp')}
                                src={require('@publicLocal/product/solarpanel_100w/h5/sec_middle_right.jpg')}
                                className="fullImgs"
                                alt={t('solarpanels_100w.second_ip')}
                            />
                        </div>
                    </div>
                </div>
                <div className="section sec_bottom">
                    <div className="sec_bottom_left">
                        <div className="tit">
                            <div className="text1">{t('solarpanels_100w.second_adjustable')}</div>
                            <div className="text2">{t('solarpanels_100w.second_highly_protective')}</div>
                        </div>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_100w/h5/sec_bottom_left.webp')}
                                src={require('@publicLocal/product/solarpanel_100w/h5/sec_bottom_left.jpg')}
                                className="fullImgs"
                                alt={t('solarpanels_100w.second_adjustable')}
                            />
                        </div>
                    </div>
                    <div className="sec_bottom_right">
                        <div className="tit">{t('solarpanels_100w.second_easy_to_plug')}</div>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_100w/h5/sec_bottom_right.webp')}
                                src={require('@publicLocal/product/solarpanel_100w/h5/sec_bottom_right.jpg')}
                                className="fullImgs"
                                alt={t('solarpanels_100w.second_easy_to_plug')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="textImg textImg1">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: t('solarpanels_100w.third_title'),
                        desc: t('solarpanels_100w.third_des'),
                        img_url: ['03.webp', '03.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textImg2">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        title: t('solarpanels_100w.six_title'),
                        synopsis: t('solarpanels_100w.six_synopsis'),
                        desc: t('solarpanels_100w.six_des'),
                        img_url: ['04.webp', '04.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textImg3">
                <TextWithImage
                    config={{ isShowVideo: true, fullScreen: false, position: 'top' }}
                    data={{
                        title: t('solarpanels_100w.four_title'),
                        synopsis: t('solarpanels_100w.four_synopsis'),
                        desc: t('solarpanels_100w.four_des'),
                        video_src: videoSource[locale] || videoSource.us,
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        title: t('solarpanels_100w.five_title'),
                        synopsis: t('solarpanels_100w.five_synopsis'),
                        desc: t('solarpanels_100w.five_des'),
                        notice: t('solarpanels_100w.five_phrase'),
                        img_url: ['06.webp', '06.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textData7">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        imgHeight: '2.32rem',
                        webpUrl,
                    }}
                    data={{
                        title: t('solarpanels_100w.seven_title'),
                        synopsis: t('solarpanels_100w.seven_synopsis'),
                        desc: t('solarpanels_100w.seven_des'),
                        img_url: ['07.webp', '07.jpg'],
                    }}
                />
                <div className="img-text text-left">{t('solarpanels_100w.seven_img_left')}</div>
                <div className="img-text text-right">{t('solarpanels_100w.seven_img_right')}</div>
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textImg8">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        webpUrl,
                    }}
                    data={{
                        title: t('solarpanels_100w.eight_title'),
                        synopsis: t('solarpanels_100w.eight_synopsis'),
                        desc: t('solarpanels_100w.eight_des'),
                        img_url: ['connectors.webp', 'connectors.jpg'],
                    }}
                />
            </div>

            <div className="whatsBox">
                <LineSpace height={0.8} background="transparent" />
                <p className="title">{t('solarpanels_100w.nine_title')}</p>
                <div className="boxImg">
                    <div className="img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_100w/h5/08.webp')}
                            src={require('@publicLocal/product/solarpanel_100w/h5/08.png')}
                            className="fullImgs"
                            alt={t('solarpanels_100w.nine_title')}
                            aria-label={t('solarpanels_100w.nine_title')}
                        />
                    </div>
                    <p className="note">{t('solarpanels_100w.nine_note')}</p>
                </div>
            </div>
            <LineSpace height={1.2} background="transparent" />
            {['nl'].includes(locale) ? (
                <ProductRecommand {...props} />
            ) : (
                <OtherList
                    data={getDetaileMoreProducts(
                        gloproductlist,
                        product[locale] || product.us,
                        '',
                        '',
                        `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                    )}
                />
            )}
        </div>
    );
}
